import axios from 'axios'

const baseApiUrl = process.env.VUE_APP_API_URL

/**
 * get file data from key
 * @param {string} key 
 */
export const getFileData = (key) => {
	let url = baseApiUrl + '/s/' + key + '/download'
	return new Promise((resolve, reject) => {
		axios.get(url)
			.then(response => {
				if(response.data && response.data.file) {
					resolve(response.data.file)	
				}
			})
			.catch(error => {
				reject(error)
			})
	})	
}

export const deleteOwnerFile = (key) => {
	let url = `${baseApiUrl}/s/${key}`
	return new Promise((resolve, reject) => {
		axios.delete(url)
			.then(response => {
				if(response.data) {
					resolve(response.data)
				}
			})
			.catch(error => {
				reject(error)
			})
	})
}

export const getSocialRedirectURL = (socialType) => {
	let url = baseApiUrl + '/social/redirect/'	+ socialType
	return new Promise((resolve, reject) => {
		axios.get(url)
			.then(response => {
				if(response.data && response.data.url) {
					resolve(response.data.url)	
				} else {
					reject("No url data.")
				}
			})
			.catch(error => {
				reject(error)
			})
	})	
}

export const getPinterestData = (token, userToken) => {
	let url = baseApiUrl + '/social/pinterest/boards' + '?user_token=' + userToken
	return new Promise((resolve, reject) => {
		axios.get(url)
			.then(response => {
				let data = response.data
				let userData = JSON.parse(data.user)
				let boards = JSON.parse(data.boards)
				resolve({user_name: userData.data.username, boards: boards.data})
			})
			.catch(error => {
				reject(error)
			})
	})
}

export const getSlackChannels = (userToken) => {
	let url = baseApiUrl + '/social/slack/channels' + '?user_token=' + userToken
	return new Promise((resolve, reject) => {
		axios.get(url)
			.then(response => {
				let data = response.data
				resolve(data)
			})
			.catch(error => {
				reject(error)
			})
	})
}

export const postToClient = (url, data) => {
	return new Promise((resolve, reject) => {
		axios.post(url, data, {headers: {
			'Content-Type': 'multipart/form-data'
		}})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

export const checkStatusFromClient = (url) => {
	return new Promise((resolve, reject) => {
		axios.get(url, {
			headers: {
				'Content-Type': 'multipart/form-data'	
			}
		})
			.then(response => {
				resolve(response)
			})
			.catch(error => {
				reject(error)
			})
	})
}

/**
 * store localStorage
 */
export const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * get from localStorage
 */
export const getStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * delete from localStorage
 */
export const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}